<ng-select [addTag]="addTagFn" [multiple]="true" [clearOnBackspace]="true" [isOpen]="false" [selectOnTab]="true" [(ngModel)]="data">
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    {{ item?.DisplayName || item?.Email }} <span *ngIf="item?.Email">&lt;{{ item?.Email }}&gt;</span>
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">X</span>
  </ng-template>
</ng-select>
